const defaultState = "TABLE";

const display = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_DISPLAY":
      return action.payload;
    default:
      return state;
  }
};

export default display;



// WEBPACK FOOTER //
// ./src/reducers/displayReducer.js